import { Field, useFormikContext } from "formik"
import React, { Fragment, useState } from "react"
import { Table } from "react-bootstrap"
import logger from "../../../../Logger"
import { getInNested } from "../dynamic-form.helper"
import { csvFileToArray, parseFileFormData } from "../import-utils"

function InputFile(props) {
  const { id, label, name, value, errorMessage, fieldData, isNestedFieldName, isRequired, enablePreview = true, ...otherProps } = props
  const { errors, touched, values } = useFormikContext()
  const normalizedNameKey = isNestedFieldName ? name : `['${name}']`
  const [showPreviewPanel, setShowPreviewPanel] = useState(false)
  const [csvArray, setCsvArray] = useState(null)

  const getCsvDataTable = (tableData) => {
    logger.info({ tableData }, "csvData")
    const headerKeys = Object.keys(Object.assign({}, ...tableData))
    logger.info({ headerKeys }, "header keys")

    return (
      <Table striped bordered hover size="sm" className="game-list-table">
        <thead>
          <tr>
            <th>#</th>
            {headerKeys.map((headEle, index) => (
              <th key={`header-${headEle}-${index}`}>{headEle}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {tableData.map((dataItem, dataIndex) => (
            <tr key={`data-${dataIndex}`}>
              <td>{dataIndex + 1}</td>
              {Object.values(dataItem).map((dataValue, valIndex) => (
                <td key={`data-value-${valIndex}`}>{dataValue}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>
    )
  }

  const handlePreviewBtnClick = () => {
    setShowPreviewPanel(!showPreviewPanel)
  }

  return (
    <Fragment>
      <div className="form-block-wrapper">
        <div className="custom-form-block flex-grow-1">
          <label htmlFor={id} className="form-label">
            {label} {isRequired && <sup>*</sup>}
          </label>
          <div className="input-group custom-field has-validation">
            <Field id={id} name={normalizedNameKey}>
              {({ field, form }) => {
                // Resolved error: https://stackoverflow.com/a/69326314
                const { value, ...otherFields } = field
                return (
                  <>
                    <label
                      className={`btn btn-primary ${
                        getInNested(form.touched, name, isNestedFieldName) && getInNested(form.errors, name, isNestedFieldName) ? "is-invalid" : ""
                      }`}
                      onClick={(e) => {
                        form.setFieldTouched(normalizedNameKey, true)
                      }}
                    >
                      <input
                        style={{ display: "none" }}
                        id={field.id}
                        type="file"
                        name={field.name}
                        {...otherFields}
                        onChange={async (e) => {
                          form.setFieldTouched(normalizedNameKey, true)
                          const selectedFile = e.target.files[0]
                          if (selectedFile) {
                            // Parse the field data for the file and update the form
                            const parsedFile = await parseFileFormData(selectedFile)
                            form.setFieldValue(normalizedNameKey, parsedFile, true)
                          }
                        }}
                      />
                      <span>{value?.name ? `File: ${value.name}` : "Browse"}</span>
                    </label>
                  </>
                )
              }}
            </Field>
            {getInNested(values, name, isNestedFieldName) && !getInNested(errors, name, isNestedFieldName) && enablePreview ? (
              <div className="preview-wrapper">
                <button
                  className="btn"
                  type="button"
                  onClick={() => {
                    const fieldValue = getInNested(values, name, isNestedFieldName)
                    if (fieldValue?.utf8) {
                      setCsvArray(csvFileToArray(fieldValue.utf8))
                    } else {
                      setCsvArray(null)
                    }
                    handlePreviewBtnClick()
                  }}
                >
                  <span className="icon-wrapper">
                    {!showPreviewPanel ? <i className="fa-solid fa-eye"></i> : <i className="fa-solid fa-eye-slash"></i>}
                  </span>
                </button>

                {showPreviewPanel && csvArray ? (
                  <div className="preview-panel preview-table">
                    <div className="table-responsive position-relative">{getCsvDataTable(csvArray)}</div>
                    <span className="panel-close icon-wrapper position-absolute clickable" onClick={() => setShowPreviewPanel(!showPreviewPanel)}>
                      <i className="fa-solid fa-xmark"></i>
                    </span>
                  </div>
                ) : null}
              </div>
            ) : null}
          </div>
          <div className="invalid-feedback">
            {getInNested(touched, name, isNestedFieldName) && getInNested(errors, name, isNestedFieldName) ? errorMessage : ""}
          </div>
        </div>
      </div>
    </Fragment>
  )
}

InputFile.propTypes = {}

export default InputFile
